import PropTypes from 'prop-types'

import {List, Map} from 'immutable'
import {useEffect} from 'react'

import AccountInformation from '../../shared_components/account_information/AccountInformation'
import AccountSummary from '../../shared_components/account_summary/AccountSummary'
import ClientActions from '../../../../../pro/src/actions/ClientActions'
import DowngradeClientController from '../../shared_components/downgrade_client/DowngradeClientController'
import EverplanDetails from '../../shared_components/everplan_details/EverplanDetails'
import FuneralHomeHeading from '../../shared_components/FuneralHomeHeading'
import RemoveClientController from '../../shared_components/remove_clients/RemoveClientController'
import storeWrapper from '../../../../../shared_components/storeWrapper'

import {
  useNotificationContext
} from '../../../../../shared_components/notifications/NotificationContext'

import {usePrevious} from '../../../../../lib/hooks'

import {legacyClientInfo} from '../../../lib/firmTools'
import {allUsersDeceased} from '../../../../../lib/tools'

import './quarterbackClient.scss'

const QuarterbackClient = props => {
  const isClientDeceased = Boolean(
    legacyClientInfo(
      props.household.data.clients,
      props.clientSeat.get('id')
    )?.deceased_at
  )

  const isLimitedClient = props.clientSeat.get('limited-client')
  const isQuarterback = props.currentUser.get('quarterback')

  const prevClientInformation = usePrevious(props.editClientNotification.data)
  const {isDifferent} = useNotificationContext()

  useEffect(() => {
    isDifferent(
      props.editClientNotification.data,
      prevClientInformation
    ).shortSuccess('Client information updated.')
  }, [props.editClientNotification.data])

  const isAnyEverplanUserActive = props.clientSeats.some(clientSeat => clientSeat.get('status') === 'Active')

  return (
    <div className='quarterback-client'>
      {props.children}
      <FuneralHomeHeading
        clientName={props.household.data.name}
        downgradeLink={
          (isQuarterback && !isLimitedClient) ? (
            <DowngradeClientController
              clientName={props.household.data.name}
              clientSeatId={props.clientSeat.get('id')}
            />
          ) : null
        }
        isQuarterback={isQuarterback}
        funeralHomeName={props.firm.get('name')}
        isLimitedClient={isLimitedClient}
      />
      <AccountInformation
        clientSeats={props.clientSeats}
        clients={props.household.data.clients}
        params={props.params}
      />
      <AccountSummary
        anyoneActive={isAnyEverplanUserActive}
        allUsersDeceased={allUsersDeceased(props.household.data.clients)}
        clientFirstName={props.clientSeat.get('first-name')}
        currentUser={props.currentUser}
        data={props.household}
        everplanSummary={props.everplanSummary}
        firmOwnership={props.firmOwnership}
        isClientDeceased={isClientDeceased}
        isLimitedClient={isLimitedClient}
        itemResponses={props.itemResponses}
        quarterbackOwnership={props.quarterbackOwnership}
      />
      <EverplanDetails {...props} everplanSummary={props.everplanSummary} />
      <RemoveClientController {...props} />
    </div>
  )
}

QuarterbackClient.propTypes = {
  clientSeat: PropTypes.instanceOf(Map),
  clientSeats: PropTypes.instanceOf(List),
  clients: PropTypes.array,
  editClientNotification: PropTypes.shape({
    data: PropTypes.shape({
      message: PropTypes.string
    })
  }),
  everplanSummary: PropTypes.instanceOf(Map),
  firm: PropTypes.instanceOf(Map),
  household: PropTypes.object,
  itemResponses: PropTypes.instanceOf(List),
  params: PropTypes.object,
  firmOwnership: PropTypes.instanceOf(Map),
  currentUser: PropTypes.instanceOf(Map),
  quarterbackOwnership: PropTypes.instanceOf(Map),
  name: PropTypes.string
}

export default storeWrapper(
  QuarterbackClient,
  [{
    actionTypes: [ClientActions.Types.DID_UPDATE_CLIENT],
    name: 'editClientNotification'
  }]
)
